import React, { useEffect, useState } from 'react';
import {
    Accordion, AccordionSummary, AccordionDetails, Typography, IconButton, Divider, Chip,
    RadioGroup, FormControlLabel, Radio, Checkbox, Select, MenuItem,
    Card,
    CardContent,
    Grid,
    Stack,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store/appStore';
import { useStyles } from '../../../assets/styles/listTableStyle';
import MediaViewer from '../../MediaViewer/MediaViewer';
import { ScoreDisplay } from '../../ScoreDisplay/ScoreDisplay';
import { getExpertTestAttempts } from '../../../redux/slices/testAttempts';
import { useParams } from 'react-router-dom';
import { STATUS } from '../../../utils/status';

const AttemptHistory = ({ attemptId, setDrawer }: any) => {
    const association_type = useSelector((state: RootState) => state.projects.association_type);
    const association_type_vendor = association_type && association_type === 'VENDOR';
    const attempts = useSelector((state: RootState) => state.testAttempts.testAttemptsExpert);
    const getStatus = useSelector((state: RootState) => state.testAttempts.getExpertTestAttemptStatus)
    //const filteredData = attempts?.results.filter((row: any) => row.expert_id === attemptId);
    const [expanded, setExpanded] = useState<string | false>(false);
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    function formatMinutes(minutes: number) {
        const hrs = Math.floor(minutes / 60);
        const min = Math.floor(minutes);
        const sec = Math.round((minutes - min) * 60);
        return <span>{hrs > 0 ? `${hrs}h ${min}m ${sec}s` : min > 0 ? `${min}m ${sec}s` : `${sec}s`}</span>;
    }

    //const sortedAttempts = filteredData[0]?.attempt_history?.slice().sort((a: any, b: any) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());

    useEffect(() => {
        dispatch(getExpertTestAttempts({ project_id: id, expert_id: attemptId }))
    }, [dispatch, id, attemptId])

    console.log({ attempts })

    return (
        <div>
            <IconButton onClick={() => setDrawer(false)} sx={{ float: 'right' }}>
                <CloseIcon sx={{ fontSize: '23px' }} />
            </IconButton>
            <div>
                <h3>Attempt Analysis</h3>
                <Divider style={{ paddingTop: '5px', width: '100%' }} />
            </div>
            <div style={{ width: 'auto', padding: 1, marginTop: '2%' }}>
                {getStatus === STATUS.SUCESS && attempts?.data.attempt_history?.length === 0 && <Typography>No Attempts Available</Typography>}
                {getStatus === STATUS.SUCESS && attempts?.data.attempt_history?.map((row: any, index: any) => {
                    return (
                        <Accordion key={row.id} expanded={expanded === row.id} onChange={handleChange(row.id)}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ padding: 1 }}>
                                <Box display="flex" alignItems="start" width="100%" flexDirection="column">
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            <strong>Attempt No: </strong>
                                            {attempts?.data.attempt_history?.length > 0 ? attempts?.data.attempt_history?.length - index : '-'}
                                        </Typography>
                                        <Chip
                                            label={row.status}
                                            color={row.status === "PASSED" ? "success" : row.status === "FAILED" ? "error" : "default"}
                                            variant="outlined"
                                            sx={{
                                                ml: 2,
                                                borderRadius: '12px',
                                                fontWeight: 'bold',
                                                textTransform: 'capitalize',
                                            }}
                                        />
                                        <Typography sx={{ ml: 2, fontWeight: 'bold' }}>
                                            <strong>Score %'ge:</strong>{" "}
                                            {/* {row.score ?? '0'} / {row.score_out_of || 0}{" "} */}
                                            {row?.score_out_of > 0 ? (row?.score / row?.score_out_of * 100).toFixed(2) + "%" : "0%"}

                                        </Typography>

                                        {row.status === "UNFINISHED" ? <></> :
                                            <Typography sx={{ ml: 15, fontSize: "16px", fontWeight: "bold", fontFamily: 'Montserrat', }}>
                                                Passing Percentage: {row?.test_settings?.test_passing_score_percentage ?? 0}%
                                            </Typography>}
                                    </Box>
                                    <Box display="flex" alignItems="center" width="100%" mt={1}>
                                        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                                            <strong>Start Time:</strong> {new Date(row.start_time).toLocaleString()}<br />
                                            <strong>Time Taken: </strong>{formatMinutes(row.time_taken_to_complete)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails>
                                <Card variant="outlined" sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
                                    <CardContent>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="body1"><strong>Start Time:</strong> <span> {new Date(row.start_time).toLocaleString()}</span></Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="body1"><strong>End Time:</strong> <span>{row.end_time ? new Date(row.end_time).toLocaleString() : '00:00'}</span></Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="body1"><strong>Score:</strong> {row.score ?? '0'} / {row.score_out_of || 0}</Typography>
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6}>
                                                <Typography variant="body1"><strong>Time Taken: </strong>{formatMinutes(row.time_taken_to_complete)}</Typography>
                                            </Grid> */}
                                        </Grid>

                                        <Divider sx={{ my: 2 }} />

                                        <Typography variant="h6" sx={{ mb: 1 }}>Actions</Typography>
                                        <Stack spacing={2}>
                                            {row.actions.length === 0 && <Typography style={{ textAlign: "center", fontFamily: "Montserrat" }}>No Response Available</Typography>}
                                            {row.actions.map((action: any) => {
                                                console.log({ row })
                                                return (
                                                    <Card
                                                        key={action.question_id}
                                                        variant="outlined"
                                                        sx={{
                                                            p: 2,
                                                            borderRadius: 2,
                                                            border: action.type === 'multi_select' ? ((() => {
                                                                const userSelected = action.selected_answer[0].selected.map((s: any) => s.index);
                                                                const correct = action.correct_answer_indexes as number[];
                                                                return correct.length === userSelected.length && correct.every(idx => userSelected.includes(idx)) ? '2px solid green' : '2px solid red';
                                                            })()
                                                            ) : association_type_vendor
                                                                ? '1px solid black'
                                                                : Array.isArray(action.correct_answer_indexes)
                                                                    ? action.selected_answer.every((ans: any) =>
                                                                        ans.selected.every((sel: any) =>
                                                                            action.correct_answer_indexes.includes(sel.index)
                                                                        )
                                                                    )
                                                                        ? '2px solid green'
                                                                        : '2px solid red'
                                                                    : action.selected_answer.every((ans: any) =>
                                                                        action.correct_answer_indexes === ans.selected[0]?.index
                                                                    )
                                                                        ? '2px solid green'
                                                                        : '2px solid red',
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <Typography variant="subtitle1"><strong>Question:</strong> {action.all_options.label}</Typography>
                                                            {/* <Typography variant="subtitle1"><strong>Score:</strong> {action.action_score.toFixed(2)}</Typography> */}
                                                            <Typography variant="subtitle1">
                                                                <ScoreDisplay score={Math.round(action.action_score)} total={Math.round(action.score_out_of)} />
                                                                {/* <strong>Score:</strong> {Math.round(action.action_score)} / {Math.round(action.score_out_of)} */}
                                                            </Typography>
                                                        </div>
                                                        <MediaViewer multimediaLinks={row?.actions[0]?.multimedia_links} />

                                                        {action.type === "radio" && (
                                                            <RadioGroup row value={action.selected_answer[0]?.selected[0]?.index}>
                                                                {action.all_options.value.map((opt: any) => (
                                                                    <FormControlLabel
                                                                        key={opt.index}
                                                                        value={opt.index}
                                                                        control={<Radio />}
                                                                        label={opt.value}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                        )}

                                                        {action.type === "checkbox" && (
                                                            <Grid container spacing={1}>
                                                                {action.all_options.value.map((opt: any) => (
                                                                    <Grid item key={opt.index}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={action.selected_answer.some((ans: any) =>
                                                                                        ans.selected.some((sel: any) => sel.index === opt.index)
                                                                                    )}
                                                                                />
                                                                            }
                                                                            label={opt.value}
                                                                        />
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        )}

                                                        {action.type === "single_select" && (
                                                            <Select size='small' fullWidth value={action.selected_answer[0]?.selected[0]?.index || ""} displayEmpty>
                                                                {action.all_options.value.map((opt: any) => (
                                                                    <MenuItem key={opt.index} value={opt.index}>{opt.value}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        )}

                                                        {action.type === "multi_select" && (
                                                            <Select size='small' multiple fullWidth value={action.selected_answer[0]?.selected.map((sel: any) => sel.index) || []} displayEmpty>
                                                                {action.all_options.value.map((opt: any) => (
                                                                    <MenuItem key={opt.index} value={opt.index}>{opt.value}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        )}
                                                        {!association_type_vendor &&
                                                            <Typography variant="body2" sx={{ color: 'green', mt: 1 }}>
                                                                <strong>Correct Answer(s):</strong> {Array.isArray(action.correct_answer_indexes)
                                                                    ? action.correct_answer_indexes
                                                                        .map((index: any) => {
                                                                            const correctOption = action.all_options.value.find((opt: any) => opt.index === index);
                                                                            return correctOption ? `${correctOption.index}. ${correctOption.value}` : '';
                                                                        })
                                                                        .join(', ')
                                                                    :
                                                                    action.all_options.value
                                                                        .filter((opt: any) => opt.index === action.correct_answer_indexes)
                                                                        .map((opt: any) => `${opt.index}. ${opt.value}`)
                                                                        .join(', ')
                                                                }
                                                            </Typography>
                                                        }
                                                    </Card>

                                                )
                                            })}
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </AccordionDetails>

                        </Accordion>
                    )
                })}
            </div>
        </div>
    );
};

export default AttemptHistory;